import { render, staticRenderFns } from "./AclPerfis.vue?vue&type=template&id=e7d8f002&scoped=true&"
import script from "./AclPerfis.vue?vue&type=script&lang=js&"
export * from "./AclPerfis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d8f002",
  null
  
)

export default component.exports